module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors/img_cs-a293ab14b886ca5accabbd144be07447.png";